export var DEFAULT_COUNTRIES = ['SG', 'MY', 'TH', 'VN', 'ID', 'PH'];